<template>
  <exo-help-dialog title="Antenna beam width">
    <p>
      Antennas often don't emmit/receive the same amount of power in all
      directions (isotropically), but rather usually have one direction where
      the the power is maximized, the boresight (the direction of peak gain).
      The antenna beam width is used for measuring the pointing loss (also known
      as the gain roll-off of the antenna) caused by the misalignment between
      the antenna boresight direction and the other communicating antenna
      (transmitter or receiver). The beamwidth of an antenna is typically taken
      to be twice the angle between the boresight and the direction where the
      power has a roll-off value of a factor of 0.5 (that is, -3 dB). As a
      general rule, the higher the gain of an antenna, the smaller its beam
      width.
    </p>
    <tooltipEquationPointingLoss />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationPointingLoss from './tooltipEquationPointingLoss.vue'
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
export default {
  name: 'tooltipBeamWidth',
  components: {
    tooltipEquationPointingLoss,
    tooltipEquationEbN0
  }
}
</script>
